import React from 'react';
import styles from './PsychologicalTesting.css.js';
import FadeIn from 'react-fade-in';
import { Parallax } from 'react-parallax';

export default function TestingDesktop() {
    return (
        <div className='psychContainer' style={styles.psychContainer}>
        <Parallax
            //blur={10}
            bgImage={require('../../../resources/testingFinal.jpg')}
            bgImageAlt="splash"
            strength={150}
            >
        <div className='psychImage' style={styles.psychImage}>
        </div>
        </Parallax>
        <div className='psychCopy' style={styles.psychCopy}>
        <FadeIn delay='2000' transitionDuration='2000' >
           <h1 style={styles.head}>Testing</h1>
           <ul>
               <li style={styles.item}> Ministry - Religious </li>
               <li style={styles.item}> Diagnostic </li>
               <li style={styles.item}> Academic </li>
               <li style={styles.item}> Intellectual </li>
               <li style={styles.item}> Pre-employment</li>
               <li style={styles.item}> Vocational </li>
               <li style={styles.item} id='trainings'> Neuropsychology </li>
           </ul>
           </FadeIn>
        </div>
        
   </div>
    )
}
